import React, { useState } from 'react';
import { Box, TextField, Button, CircularProgress, Alert } from '@mui/material';
import { searchUser } from '../services/users';

const UserSearch = ({ onUserFound }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSearch = async (e) => {
    e.preventDefault();
    if (!searchTerm.trim()) return;

    setLoading(true);
    setError('');

    try {
      const users = await searchUser(searchTerm.trim());
      
      if (users.length === 0) {
        setError('No users found. Try searching with a different user ID or username.');
      } else if (users.length === 1) {
        // If only one user is found, select it immediately
        onUserFound(users[0]);
      } else {
        // If multiple users are found, let the parent component handle it
        onUserFound(users);
      }
    } catch (err) {
      setError('Error searching for user: ' + (err.message || 'Unknown error'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box component="form" onSubmit={handleSearch} sx={{ mb: 4 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
        <TextField
          label="Search by User ID or Username"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          fullWidth
          sx={{ mr: 2 }}
          disabled={loading}
        />
        <Button
          variant="contained"
          type="submit"
          disabled={loading || !searchTerm.trim()}
        >
          {loading ? <CircularProgress size={24} /> : 'Search'}
        </Button>
      </Box>
      
      {error && <Alert severity="error">{error}</Alert>}
    </Box>
  );
};

export default UserSearch;
